import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { ProcessPageComponent } from './features/process/pages/process-page/process-page.component';
import { AccountSettingsComponent } from './features/account/account-settings/account-settings.component';
import { AuthGuard } from './core/guards/auth-guard';
import { ProcessFullViewComponent } from './features/process/components/shared/process-fullview/process-fullview.component';
import { DocumentsIssuedComponent } from './features/document/components/documents-issued/documents-issued.component';

export const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'process', pathMatch: 'full' }, // Redirect to 'process' if authenticated
      { path: 'process', component: ProcessPageComponent },
      { path: 'process/:id', component: ProcessFullViewComponent },
      { path: 'documents-issued', component: DocumentsIssuedComponent },
      { path: 'account-settings', component: AccountSettingsComponent },
      { path: '**', redirectTo: 'process' }, // Wildcard route within authenticated section
    ],
  },
  { path: '**', redirectTo: 'login' }, // Catch-all route for unauthenticated users
];
